export { default, Skeleton } from './Skeleton'
